<script>
	import { siteTitle } from '$lib/stores/nav';

	import { onMount } from 'svelte';

	onMount(() => {
		$siteTitle = 'Nutzungsbedingungen';
	});
</script>

<div class="mt-4">
	<h1 class="text-4xl mb-10">Nutzungs&shy;bedingungen</h1>

	<section class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7">
		<h2>Benutzer:innen-Konto:</h2>
		<div class="rte">
			<p>
				Für die Registrierung Ihres Benutzer:innen-Kontos ist die Angabe einer
				E-Mail-Adresse, eines frei wählbaren Benutzer:innen-Namens und eines Passworts
				erforderlich. Bitte beachten Sie, dass Ihr frei wählbarer <b
					>Benutzer:innen-Name öffentlich sichtbar</b
				> ist und jede Ihrer Transkriptionen mit diesem Benutzer:innen-Namen veröffentlicht wird.
				Die Registrierung darf nur persönlich vorgenommen werden. Eine automatisierte Erstellung
				von Konten oder auch die Kontoeröffnung „für andere bzw. im Namen anderer“ ist nicht
				gestattet. Jede:r Benutzer:in verpflichtet sich, im Rahmen seiner/ihrer Anmeldung nicht
				die Rechte Dritter zu verletzen. Eine Verletzung der Rechte Dritter ist unter anderem
				dann gegeben, wenn personenbezogene Informationen oder sonstige Daten Dritter (z. B.
				der Name oder die E-Mail-Adresse) ohne deren Einwilligung verwendet werden.
			</p>
			<p>
				Ihre personenbezogenen Daten werden von den Museen der Stadt Wien streng vertraulich
				behandelt (Details siehe Datenschutz).
			</p>
			<p>
				Als Benutzer:in sind Sie für alle Ihre Aktivitäten verantwortlich. Bezogen auf Ihre
				Aktivitäten halten Sie die Museen der Stadt Wien bei allfälligen Inanspruchnahmen
				durch Dritte schad- und klaglos. Wir ersuchen Sie daher, Ihre Login-Daten
				vertraulich zu behandeln und nicht an Dritte weiterzugeben. Sollten Sie von einem
				Missbrauch Ihres Kontos oder von einem Sicherheitsproblem erfahren, bitten wir Sie
				um Mitteilung an <a href="mailto:datenschutz@wienmuseum.at"
					>datenschutz@wienmuseum.at</a
				>.  Bei Missbrauch Ihres Kontos wird Ihr Konto von uns gesperrt oder gelöscht.
			</p>
			<p>
				Die Museen der Stadt Wien behalten sich vor, Sie zum Zwecke von Informationen zu
				unserer Crowdsourcing-Aktion via angegebener E-Mail-Adresse zu kontaktieren.
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Haftungs&shy;ausschluss:</h2>
		<div class="rte">
			<p>
				Die Informationen auf dieser Website wurden mit großer Sorgfalt zusammengestellt.
				Für Richtigkeit, Vollständigkeit und Aktualität der Angaben können die Museen der
				Stadt Wien jedoch weder Garantie noch Haftung übernehmen.
			</p>
			<p>
				Für die Beiträge der Benutzer:innen übernehmen die Museen der Stadt Wien keine
				Verantwortung. Gleiches gilt auch für alle von den Museen der Stadt Wien oder von
				den Benutzer:innen eingestellten Links zu anderen Websites. Da die Museen der Stadt
				Wien auf den Inhalt dieser Websites keinen Einfluss haben, übernehmen sie dafür
				keine Verantwortung.
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Rechte&shy;übertragung:</h2>
		<div class="rte">
			<p>
				Benutzer:innen stimmen mit dem Speichern der Transkriptionen der unwiderruflichen
				und unentgeltlichen Übertragung sämtlicher Nutzungs- und Bearbeitungsrechte (u.a.
				Vervielfältigungs-, Verbreitungs-, Sende- und Zurverfügungstellungsrecht sowie Recht
				der öffentlichen Wiedergabe) an allen Texten/gespeicherten Inhalten unbefristet,
				weltweit und exklusiv an die Museen der Stadt Wien zu (Werknutzungsrechte). Die
				Nutzung von Bearbeitungen durch die Museen der Stadt Wien und von ihr ermächtigen
				Dritten ist gestattet. Die Museen der Stadt Wien sind berechtigt, sämtliche der ihr
				zukommenden Nutzungs- und Bearbeitungsrechte Dritten zu übertragen. Darüber hinaus
				stimmen die Benutzer:innen zu, dass die Texte auf dieser Plattform der Allgemeinheit
				zur Weiterverwendung zur Verfügung gestellt werden. Die Museen der Stadt Wien
				behalten sich außerdem das Recht vor, die Texte ohne Nennung der Urheber:innen der
				transkribierten Texte selbst oder durch Dritte weiterzuverwenden.
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Laufzeit:</h2>
		<div class="rte">
			<p>
				Die Crowdsourcing-Website der Museen der Stadt Wien steht zeitlich begrenzt zur
				Verfügung. Benutzer:innen haben keinen Anspruch auf die permanente Erreichbarkeit
				des Services und Ihres Benutzer:innen-Kontos. Es bleibt den Museen der Stadt Wien
				jederzeit freigestellt, die Seite zeitweise oder dauerhaft abzuschalten sowie die
				dort gespeicherten Inhalte zu löschen, zu verändern oder zu ergänzen.
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Rechtliche Schritte:</h2>
		<div class="rte">
			<p>
				Bei Zuwiderhandeln gegen Bestimmungen dieser Nutzungsbedingungen behalten sich die
				Museen der Stadt Wien rechtliche Schritte vor. Im Falle von Rechtsstreitigkeiten ist
				das sachlich zuständige Gericht am Sitz der Stadt Wien, Wien 1., Rathaus,
				ausschließlich zuständig. Es gilt die Anwendung österreichischen Rechtes unter
				Ausschluss der Kollisionsnormen als vereinbart.
			</p>
		</div>
	</section>
</div>
